import React from 'react';
import PropTypes from "prop-types";
import Table from "../../common/components/Table/Table";
import {Button, Checkbox, Confirm, Modal} from "semantic-ui-react";
import TestcacheListRow from "./TestcacheListRow";
import {generateCSVReport} from "../../report-generation/veritas-report-gen/ReportGeneratorActions";
import {connect} from "react-redux";
import AddEditTestcacheModal from "./AddEditTestcacheForm";
import {
    addTestcacheRecord,
    deleteTestcacheRecord,
    editTestcacheRecord,
    generatePostmanReq,
    selectAllTestcache,
    toggleAddTestcacheRecordsModal,
    toggleDeleteTestcacheRecordsModal,
    toggleEditTestcacheRecordsModal
} from "../actions/TestcacheActions";

export class TestcacheTable extends React.Component {

    static propTypes = {
        TestcacheData: PropTypes.array,
    }

    getIsTestcacheRecordSelected = (recordId) => {
        return this.props.selected_testcache_records.includes(recordId);
    }

    handleTestcacheCheckboxSelect = (e, {checked}) => {
        const recordIds = this.props.filtered_testcache_records.map(record => {
            return record.guid
        });
        this.props.selectAllTestcache(recordIds, checked);
    };

    handleCSVReportClick = () => {
        const {selected_testcache_records} = this.props;
        const formattedIds = selected_testcache_records.join("%2C");
        this.props.generateCSVReport(formattedIds);
    };

    handleAddTestcacheClick = () => {
        this.props.toggleTestcacheModal();
    }

    handleEditTestcacheClick = () => {
        this.props.toggleEditTestcacheModal();
    }

    handleAddTestcacheFormSubmit = () => {
        this.props.addTestcache(this.props.testcacheObject);
    }

    handleEditTestcacheFormSubmit = () => {
        this.props.editTestcache(this.props.testcacheObject, this.props.testcacheObject.guid);

    }

    handleGeneratePostmanBodyClick = () => {
        this.props.generatePostman();
    }

    handleCancelDeleteClick = () => {
        this.props.toggleDeleteTestcacheModal();
    }

    handleDeleteTestcacheClick = () => {
        this.props.deleteTestcache(this.props.testcacheIDForDelete);
    }

    get tableHeaders() {
        const headers = [
            <Table.Header key="checkbox">
                <Checkbox
                    checked={this.props.all_testcache_records_selected}
                    onChange={this.handleTestcacheCheckboxSelect}
                />
            </Table.Header>,
            <Table.Header key="edit-delete"> </Table.Header>,
            <Table.Header key="name">Full Name</Table.Header>,
            <Table.Header key="address-lines">Address Lines</Table.Header>,
            <Table.Header key="locality-plus">Locality +</Table.Header>,
            <Table.Header key="national-id">National ID</Table.Header>,
            <Table.Header key="data-source-type">Data Source Type</Table.Header>,
            <Table.Header key="country">Country</Table.Header>,
            <Table.Header key="phone-number">Phone</Table.Header>,
            <Table.Header key="date-of-birth">Date of Birth</Table.Header>,
        ];
        return headers.filter(header => header !== null);
    }


    get tableItems() {
        return this.props.TestcacheData.map(testcache => (
            <TestcacheListRow
                key={testcache.id}
                testcacheRecord={testcache}
                addressLine1={testcache.addressline1}
                addressLine2={testcache.addressline2}
                addressLine3={testcache.addressline3}
                administrativeArea={testcache.administrativearea}
                completeName={testcache.completename}
                countryCode={testcache.countrycode}
                dataSourceType={testcache.data_source_type}
                dob={testcache.dob}
                givenFullName={testcache.givenfullname}
                houseNumber={testcache.housenumber}
                locality={testcache.locality}
                nationalId={testcache.nationalid}
                phone={testcache.phone}
                postalCode={testcache.postalcode}
                surnameFirst={testcache.surname_first}
                thoroughfare={testcache.thoroughfare}
                id={testcache.id}
                guid={testcache.guid}
                isSelected={this.getIsTestcacheRecordSelected(testcache.guid)}
            />
        ))
    }

    render() {
        return (
            <div>
                <div style={{padding: "20px 20px 0 30px"}}>
                    <Button
                        icon="file excel outline" size="big"
                        disabled={!this.props.all_testcache_records_selected &&
                        !this.props.some_testcache_records_selected }
                        onClick={this.handleCSVReportClick}
                    />
                    <Button
                        style={{float: "right"}}
                        color="blue"
                        icon="add"
                        content="Add a new KYC TestCache Record"
                        onClick={this.handleAddTestcacheClick}
                    />
                </div>
                <div className="testcache-list-container">
                    <div className="sticky-table-container">
                        <Table
                            className="sticky-table"
                            headers={this.tableHeaders}
                        >
                            {this.tableItems}
                        </Table>
                    </div>
                </div>

                <Modal
                    centered={false}
                    dimmer="blurring"
                    open={this.props.addTestcacheModalOpen}
                >
                    <Modal.Header>
                        {"Add a new KYC TestCache Record"}
                    </Modal.Header>
                    <Modal.Content scrolling>
                        <AddEditTestcacheModal />
                    </Modal.Content>
                    <Modal.Actions>
                        <Button
                            type="button"
                            color="blue"
                            inverted
                            onClick={this.handleGeneratePostmanBodyClick}>
                            Generate Postman Request
                        </Button>
                        <Button
                            type="button"
                            color="red"
                            inverted
                            onClick={this.handleAddTestcacheClick}>
                            Close
                        </Button>
                        <Button
                            type="submit"
                            color="green"
                            inverted
                            onClick={this.handleAddTestcacheFormSubmit}>
                            Submit
                        </Button>
                    </Modal.Actions>
                </Modal>

                <Modal
                    centered={false}
                    dimmer="blurring"
                    open={this.props.editTestcacheModalOpen}
                >
                    <Modal.Header>
                        {"Edit a KYC TestCache Record"}
                    </Modal.Header>
                    <Modal.Content scrolling>
                        <AddEditTestcacheModal />
                    </Modal.Content>
                    <Modal.Actions>
                        <Button
                            type="button"
                            color="red"
                            inverted
                            onClick={this.handleEditTestcacheClick}>
                            Close
                        </Button>
                        <Button
                            type="submit"
                            color="green"
                            inverted
                            onClick={this.handleEditTestcacheFormSubmit}>
                            Submit
                        </Button>
                    </Modal.Actions>
                </Modal>

                <Confirm
                    open={this.props.deleteTestcacheWarning}
                    content="Are you sure you want to delete this Testcache Record."
                    onCancel={this.handleCancelDeleteClick}
                    onConfirm={this.handleDeleteTestcacheClick}
                />


            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    all_testcache_records_selected: state.support.testcache.all_testcache_records_selected,
    selected_testcache_records: state.support.testcache.selected_testcache_records,
    filtered_testcache_records: state.support.testcache.filtered_testcache_records,
    some_testcache_records_selected: state.support.testcache.some_testcache_records_selected,

    testcacheObject: state.support.addEditTestcache.testcacheObject,
    addTestcacheModalOpen: state.support.addEditTestcache.addTestcacheModalOpen,
    editTestcacheModalOpen: state.support.addEditTestcache.editTestcacheModalOpen,
    deleteTestcacheWarning: state.support.addEditTestcache.deleteTestcacheWarning,
    testcacheIDForDelete: state.support.addEditTestcache.testcacheIDForDelete,
});

const mapDispatchToProps = dispatch => ({
    selectAllTestcache: (recordIds, isSelected) => {dispatch(selectAllTestcache(recordIds, isSelected))},
    generateCSVReport: (selectedIds) => {dispatch(generateCSVReport(selectedIds))},
    generatePostman: () => {dispatch(generatePostmanReq())},
    toggleTestcacheModal: () => {dispatch(toggleAddTestcacheRecordsModal())},
    toggleEditTestcacheModal: () => {dispatch(toggleEditTestcacheRecordsModal())},
    toggleDeleteTestcacheModal: () => {dispatch(toggleDeleteTestcacheRecordsModal())},
    addTestcache: (testcacheObject) => {dispatch(addTestcacheRecord(testcacheObject))},
    editTestcache: (testcacheObject, testcacheGUID) => {dispatch(editTestcacheRecord(testcacheObject, testcacheGUID))},
    deleteTestcache: (testcacheGUID) => {dispatch(deleteTestcacheRecord(testcacheGUID))},
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(TestcacheTable)
